import { Sparkles } from "lucide-react";
import { cx } from "../../utils";

const tones = {
  brand: {
    ring: "ring-brand-100",
    bg: "bg-gradient-to-br from-brand-50 to-brand-100/40",
    icon: "text-brand-600",
  },
  violet: {
    ring: "ring-violet-100",
    bg: "bg-gradient-to-br from-violet-50 to-violet-100/40",
    icon: "text-violet-600",
  },
  emerald: {
    ring: "ring-emerald-100",
    bg: "bg-gradient-to-br from-emerald-50 to-emerald-100/40",
    icon: "text-emerald-600",
  },
  amber: {
    ring: "ring-amber-100",
    bg: "bg-gradient-to-br from-amber-50 to-amber-100/40",
    icon: "text-amber-600",
  },
  rose: {
    ring: "ring-rose-100",
    bg: "bg-gradient-to-br from-rose-50 to-rose-100/40",
    icon: "text-rose-600",
  },
};

const EmptyState = ({ icon, title, description, action, tone = "brand" }) => {
  const t = tones[tone] || tones.brand;
  return (
    <div className="flex flex-col items-center justify-center text-center py-14 px-6">
      <div className="relative w-16 h-16 mb-5">
        <div className={cx("absolute inset-0 rounded-2xl ring-1", t.bg, t.ring)} />
        <div className={cx("absolute -inset-3 rounded-3xl opacity-40 blur-md", t.bg)} />
        <div
          className={cx(
            "relative w-full h-full rounded-2xl flex items-center justify-center",
            t.icon,
          )}
        >
          {icon ?? <Sparkles size={24} />}
        </div>
      </div>
      <h3 className="text-base font-semibold text-ink-900 tracking-tight">{title}</h3>
      {description && (
        <p className="text-sm text-ink-500 mt-1.5 max-w-sm leading-relaxed">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
};

export default EmptyState;
